import { render, staticRenderFns } from "./ChangeUserPasswordModal.vue?vue&type=template&id=016233bb&"
import script from "./ChangeUserPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ChangeUserPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports